import * as React from 'react';
import {Image} from 'semantic-ui-react';

interface ProMTLogoProps {
    color?: "Black_small" | "Black_large" | "Full_Black" | "Full_Black_small" | "Full_Black_large" | "White_small" | "White_large";
}

interface ProMTLogoStates {
}

export default class ProMTLogo extends React.Component<ProMTLogoProps, ProMTLogoStates> {
    constructor(props: ProMTLogoProps) {
        super(props);

        this.state = {};
    }

    render() {

        let logoType = "ProMT_";
        switch (this.props.color) {
            case "Black_small":
                logoType += "Black_30";
                break;
            case "Black_large":
                logoType += "Black_70";
                break;
            case "Full_Black":
                logoType += "Full_Black";
                break;
            case "Full_Black_small":
                logoType += "Full_Black_30";
                break;
            case "Full_Black_large":
                logoType += "Full_Black_70";
                break;
            case "White_small":
                logoType += "White_30";
                break;
            case "White_large":
                logoType += "White_70";
                break;
            default:
                logoType += "White_70";
                break;
        }

        return (
            <div className="logo">
                <div className="logo-image">
                    <Image centered={true} src={"./images/Logos/" + logoType + ".png"} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ProMTLogo.tsx